const prefix = '[TBH]'
const Logger = {
  /* @params: input (string) */
  info: input => {
    console.log(`${prefix} ${input}`)
  },
  /* @params: input (string) */
  warn: input => {
    console.warn(`${prefix} ${input}`)
  },
  /* @params: input (string), error (anything) */
  error: (input, error) => {
    if (input && error) console.error(`${prefix} ${input}`, error)
    if (input && !error) console.error(`${prefix} ${input}`)
  },
  /* @params: input (object) */
  obj: input => {
    console.log(prefix, input)
  }
}

export {
  Logger
}
